// extracted by mini-css-extract-plugin
export default {"nsa_section_edit_tab_page":"NSASectionEditTabPage_nsa_section_edit_tab_page__-8gLn"};